import React, {useRef,useState,useEffect,useMemo} from "react";
import {useLocation, Route, Switch, Redirect, useHistory} from "react-router-dom";
import {Container} from "reactstrap";

import AuthNavbar from "components/Navbars/AuthNavbar.js";
import AuthFooter from "components/Footers/AuthFooter.js";
import {
	

	 Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
	Button,
} from "reactstrap";
import routes from "routes.js";
import {AnimatePresence} from "framer-motion";
import Loader from "../components/Core/Loader";
import useSession from "hooks/useSession";
import ErrorModal from "components/Core/ErrorModal";
import CardType from "lib/Core/Backend/Controllers/CardType";

const Auth = (props) => {
    const {token} = props;
	import("bootstrap/dist/css/bootstrap.css").then(() => import("assets/scss/paper-dashboard.scss?v=1.3.0").then(() => import ("perfect-scrollbar/css/perfect-scrollbar.css")));
	const mainContent = useRef();
	const location = useLocation();
	const history = useHistory();
	const session = useSession();
	const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');
	const [maintainModal,setMainTainModal] = React.useState(false);
	const toggleConfirm = () => setMainTainModal(!maintainModal);
	const cardTypeCtl = useMemo(() => new CardType(token),[token]);
	React.useEffect(() =>
	{
		document.body.style.backgroundColor = "#cdcdcd";
		return () =>
		{
			document.body.style.backgroundColor = "inherit";
		};
	}, []);

	React.useEffect(() =>
	{
		document.documentElement.scrollTop = 0;
		document.scrollingElement.scrollTop = 0;
		mainContent.current.scrollTop = 0;
	}, [location]);

	React.useEffect(() => {
		let token = sessionStorage.getItem('accessToken');
		token && history.push('/admin/dashboard')
	},[history, session])

	const getRoutes = (routes) =>
	{
		return routes.map((prop, key) =>
		{
			if (prop.layout === "/auth")
			{
				return (
					<Route
						path={prop.layout + prop.path}
						component={prop.component}
						key={key}
					/>
				);
			}
			else
			{
				return null;
			}
		});
	};

	const hideErrorModal = () => {
		setIsErrorModalOpen(false);
		setErrorMessage('');
	  };
	  const handleMaintainModalOff = () =>{
		setMainTainModal(false);
	}
	  const mainatainBackend = () => {
		fetch(`${process.env.REACT_APP_BACKEND_URL}private/auth/maintenance-mode/${true}`)
		
		.then((response) => {
		  
		  toggleConfirm();
		})
		.catch((error) => {
			console.error(`Error: ${error}`);
	})
	
	}
let url;
let maintainCalled = false;
const fetchData = () => {
 url = process.env.REACT_APP_MAINTAIN_URL
    fetch(url)
        .then((response) => {
            if (!response.ok) {
				if(!maintainCalled){
					maintainCalled = true;
					if (response.status === 502 || response.status === 503 || response.status === 504) {
						mainatainBackend();
					}
				}
				
                throw new Error(`HTTP error! Status: ${response.status}`);
				
            }
            return response.json();
        })
        .then((data) => {
			if(data.Status === "OK"){
			
			}else{
				if (!maintainCalled) { 
					maintainCalled = true;
					mainatainBackend();
				}
			}
            
        })
        .catch((error) => {
            console.error(`Error: ${error}`);
			// if (!maintainCalled) { 
            //     maintainCalled = true; 
            //     mainatainBackend(); 
            // }
        })
       
};

	
	  let pollingInterval;
	
	  useEffect(() => {
		pollingInterval = setInterval(() => {
		  fetchData();
		}, 20000);
	  
		return () => {
		  clearInterval(pollingInterval);
		};
	  }, []);
	  


	return (<>
			<Loader notOnLoad={true}/>
			<div className="main-content" ref={mainContent}>
				{/* <AuthNavbar/> */}
				<AnimatePresence initial={true} exitBeforeEnter={true}>
					{/* Page content */}
				</AnimatePresence>
				<Container className="mt--8 pb-5">
					<Switch>
						{getRoutes(routes)}
						<Redirect from="*" to="/auth/login"/>
					</Switch>
				</Container>
			</div>
			<AuthFooter />
			<Modal isOpen={maintainModal} toggle={toggleConfirm} centered={true} backdrop="static">
                    <ModalHeader className="custom_header_colour align-items-center" toggle={toggleConfirm}>
                        <h3 className='mb-0 ' style={{ fontSize: '20px' }}>Server Alert</h3>
                    </ModalHeader>
                    <ModalBody>
                        <p className="card-just-text"  style ={{fontSize:"20px"}}>
                           The Server is on Maintaince 
                        </p>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={handleMaintainModalOff}>Cancel</Button>{' '}
                        
                    </ModalFooter>
                </Modal>
		
		</>
	);
};

export default Auth;
